import axios from 'axios'
import AscentiaService from './ascentiaService'
import { saveAs } from 'file-saver'

const values = {
  attachments: null,
  attachmentTypesData: null,
  attachmentsByTypeData: null,
  downloadAttachment: null,
}

let deleteAttachmentsCall = null
let saveAttachmentsCall = null
const uploadAttachmentCall = []

const getters = {
  attachments(attachmentId) {
    return axios.get(`/Attachment/${attachmentId}`)
  },
  attachmentTypesData() {
    return axios.get('/Attachment/fileattachmentypes')
  },
  attachmentsByTypeData(fileType) {
    return axios.get(`/Attachment/Filetype/${fileType}`)
  },
  downloadAttachment(attachment) {
    return axios
      .get(`/Attachment/${attachment.id}`, { responseType: 'blob' })
      .then(response => {
        saveAs(response.data, attachment.label)
      })
      .catch(console.error)
  },
}

const saves = {
  attachments(attachment) {
    if (Array.isArray(attachment)) {
      if (saveAttachmentsCall) {
        saveAttachmentsCall.cancel(
          'Only one save group request allowed at a time.',
        )
      }
      saveAttachmentsCall = axios.CancelToken.source()
      const list = attachment.map(item => {
        return axios.put(
          `/Attachment/${item.id}/ExtVisible`,
          `${item.isExternallyVisible}`,
          {
            cancelToken: saveAttachmentsCall.token,
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
      })
      return axios.all(list)
    } else {
      if (attachment.cancel && uploadAttachmentCall.length) {
        uploadAttachmentCall.forEach((call, index) => {
          if (call.attachment === attachment.file.displayName) {
            call.cancelToken.cancel('Upload removed.')
            uploadAttachmentCall.splice(index, 1)
          }
        })
      } else {
        const newToken = {
          cancelToken: axios.CancelToken.source(),
          attachment: attachment.fileUpload.name,
        }
        uploadAttachmentCall.push(newToken)
        const formData = new FormData()
        formData.append('AttachmentTypeId', attachment.attachmentTypeId)
        formData.append('FileUpload', attachment.fileUpload)
        formData.append('IsExternallyVisible', attachment.isExternallyVisible)

        return axios.post('/Attachment', formData, {
          cancelToken: newToken.cancelToken.token,
        })
      }
    }
  },
}

const deletes = {
  attachments(attachments) {
    if (deleteAttachmentsCall) {
      deleteAttachmentsCall.cancel(
        'Only one delete group request allowed at a time.',
      )
    }
    deleteAttachmentsCall = axios.CancelToken.source()
    const list = attachments.map(item => {
      return axios.delete(`/Attachment?attachmentId=${item}`, {
        cancelToken: deleteAttachmentsCall.token,
      })
    })
    return axios.all(list)
  },
}

export default class AttachmentsService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
